import styled from "styled-components";

export const ContainerCreateAccountLogin = styled.section`
  span {
    display: block;
    text-align: center;
    font-size: var(--sz-text-2);
    color: var(--color-gray-3);
    margin: 2.125rem 0 1.375rem;
  }
`;
